import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    SimpleChange
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { USTreasury } from '../../../../models/us-treasury';

const TICKER_NUMBER_FORMAT = '1.3-3';

@Component({
    selector: 'muni-gameday-treasury-ticker',
    templateUrl: './treasury-ticker.template.html',
    styleUrls: ['./treasury-ticker.styles.scss']
})
export class TreasuryTickerComponent implements OnChanges {
    @Input()
    treasury: USTreasury;
    @Input()
    highlightName = false;

    public changeClass: string;
    public yieldDiff: number;
    public numberFormat: string = TICKER_NUMBER_FORMAT;

    constructor(private decimalPipe: DecimalPipe) {}

    public ngOnChanges(changes: SimpleChanges): void {
        const treasuryChanges: SimpleChange = changes.treasury;

        if (treasuryChanges.previousValue !== treasuryChanges.currentValue) {
            const treasury: USTreasury = treasuryChanges.currentValue;

            this.yieldDiff = treasury.previous
                ? treasury.current.yield - treasury.previous.yield
                : 0;
            this.setChangeClass(treasuryChanges.currentValue);
        }
    }

    private setChangeClass(treasury: USTreasury): void {
        const changeAmount: number = parseFloat(
            this.decimalPipe.transform(this.yieldDiff, TICKER_NUMBER_FORMAT)
        );
        if (changeAmount > 0) {
            this.changeClass = 'negative';
        } else {
            this.changeClass = changeAmount < 0 ? 'positive' : 'neutral';
        }
    }
}
